import { u21CreateSlice } from 'app/shared/thunk/u21CreateSlice';
import { PayloadAction } from '@reduxjs/toolkit';
import { Filter } from 'app/modules/filters/models';
import { u21CreateAsyncThunk } from 'app/shared/thunk/u21CreateAsyncThunk';
import { LocalStorageKeys } from 'app/shared/constants/localStorage';

export const REPORT_DASHBOARD_SLICE_NAME = 'reportDashboard';

interface ReportDashboardState {
  optIn: boolean;
  programEfficiencyAlertDashboardFilters: Filter[];
  programEfficiencyCaseDashboardFilters: Filter[];
  programEfficiencySarDashboardFilters: Filter[];
}

const INITIAL_STATE: ReportDashboardState = {
  optIn: true,
  programEfficiencyAlertDashboardFilters: [],
  programEfficiencyCaseDashboardFilters: [],
  programEfficiencySarDashboardFilters: [],
};

export const setProgramEfficiencyAlertDashboardFilters = u21CreateAsyncThunk<
  Filter[],
  Filter[]
>(
  `${REPORT_DASHBOARD_SLICE_NAME}/SET_PROGRAM_EFFICIENCY_ALERT_DASHBOARD_FILTERS`,
  (payload) => {
    localStorage.setItem(
      LocalStorageKeys.PROGRAM_EFFICIENCY_ALERT_DASHBOARD_FILTERS,
      JSON.stringify(payload),
    );
    return payload;
  },
);

export const setProgramEfficiencyCaseDashboardFilters = u21CreateAsyncThunk<
  Filter[],
  Filter[]
>(
  `${REPORT_DASHBOARD_SLICE_NAME}/SET_PROGRAM_EFFICIENCY_CASE_DASHBOARD_FILTERS`,
  (payload) => {
    localStorage.setItem(
      LocalStorageKeys.PROGRAM_EFFICIENCY_CASE_DASHBOARD_FILTERS,
      JSON.stringify(payload),
    );
    return payload;
  },
);

export const setProgramEfficiencySarDashboardFilters = u21CreateAsyncThunk<
  Filter[],
  Filter[]
>(
  `${REPORT_DASHBOARD_SLICE_NAME}/SET_PROGRAM_EFFICIENCY_SAR_DASHBOARD_FILTERS`,
  (payload) => {
    localStorage.setItem(
      LocalStorageKeys.PROGRAM_EFFICIENCY_SAR_DASHBOARD_FILTERS,
      JSON.stringify(payload),
    );
    return payload;
  },
);

export const slice = u21CreateSlice({
  initialState: INITIAL_STATE,
  name: REPORT_DASHBOARD_SLICE_NAME,
  reducers: {
    setProgramEfficiencyDashboardOptIn: (
      draft,
      action: PayloadAction<boolean>,
    ) => {
      draft.optIn = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        setProgramEfficiencyAlertDashboardFilters.fulfilled,
        (draft, action) => {
          draft.programEfficiencyAlertDashboardFilters = action.payload;
        },
      )
      .addCase(
        setProgramEfficiencyCaseDashboardFilters.fulfilled,
        (draft, action) => {
          draft.programEfficiencyCaseDashboardFilters = action.payload;
        },
      )
      .addCase(
        setProgramEfficiencySarDashboardFilters.fulfilled,
        (draft, action) => {
          draft.programEfficiencySarDashboardFilters = action.payload;
        },
      );
  },
});

export const { setProgramEfficiencyDashboardOptIn } = slice.actions;
export default slice.reducer;
